import { VIEW_MODES } from "CONSTANT/ViewModes/AppViewModes";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";

export const useAppViewMode = () => {
  const [appViewMode, setAppViewMode] = useState("Web");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramValue = params.get("viewmode");

    if (paramValue || window.location.pathname.includes("standalone")) {
      setAppViewMode(VIEW_MODES.OUTLOOK);
    }
  }, []);

  return { appViewMode };
};
